module.exports = __webpack_public_path__ + "img/costal-6-1.087707a9.jpg";